/*
 * @Author: LiuMouLiang
 * @Date:   2021-11-25 09:41:01
 * 导航菜单
 */
/* eslint-disable */

export default [
    {
        title: '产品中心',
        icon: 'el-icon-box',
        child: [
            {
                title: '团险产品',
                path: '/entry',
            },
            {
                title: '历史报价',
                path: '/history-quote',
            },
        ]
    },
    {
        title: '团险订单',
        icon: 'el-icon-notebook-2',
        child: [
            {
                title: '订单列表',
                path: '/orderList',
            },
            {
                title: '待完善订单',
                path: '/unfinishList',
            },
        ]
    },
    {
        title: '团险保全',
        icon: 'el-icon-suitcase-1',
        child: [
            {
                title: '发起保全',
                path: '/initiate-preservation',
            },
            {
                title: '保全列表',
                path: '/preservation-list',
            },
        ]
    },
]



// WEBPACK FOOTER //
// ./src/router/menu.js